import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { useTranslation } from "react-i18next";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const API_URL = "https://vipart-backend.onrender.com";

export default function SignUp() {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const [tempUserId, setTempUserId] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState("");
  const [step, setStep] = useState("form"); // "form" | "verify"
  const usernameRegex = /^[a-zA-Zა-ჰ0-9_-]{3,20}$/;

const TRIAL_DAYS = 14;

const TRIAL_MS =
  TRIAL_DAYS * 24 * 60 * 60 * 1000;

const MONTH_MS =
  30 * 24 * 60 * 60 * 1000;


// ✅ ADD THIS HERE
useEffect(() => {
  if (verified) {
    navigate("/profile/edit");
  }
}, [verified, navigate]);

  // ================= EMAIL SIGNUP =================
  const handleSignUp = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

if (!username.trim()) {
  setError(t("signup.usernameRequired"));
  setLoading(false);
  return;
}

if (!usernameRegex.test(username)) {
  setError(t("signup.usernameInvalid"));
  setLoading(false);
  return;
}

    try {
      const id = crypto.randomUUID();
      setTempUserId(id);

      const res = await fetch(`${API_URL}/send-verification`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          userId: id,
        }),
      });

      if (!res.ok) {
        throw new Error("Verification request failed");
      }

      setStep("verify");
      setVerified(false);
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  // ================= VERIFY CODE =================
  const handleVerifyCode = async () => {
  console.log("🔵 VERIFY START");
  console.log("USERNAME STATE:", username);
  console.log("EMAIL:", email);

    setLoading(true);

    if (!tempUserId) {
      setError("Session expired. Please sign up again.");
      setLoading(false);
      return;
    }

    try {
      const res = await fetch(`${API_URL}/verify-code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: tempUserId,
          code: code,
        }),
      });

      if (!res.ok) {
        throw new Error("Verification request failed");
      }

      const data = await res.json();

      if (data.success) {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );

        const user = userCredential.user;

const now = Date.now();

console.log("🟢 FIREBASE USER CREATED:", user.uid);
console.log("USERNAME BEFORE FIRESTORE SAVE:", username);

        // PRIVATE
await setDoc(doc(db, "users", user.uid), {
  email: user.email,
  createdAt: new Date().toISOString(),
  verified: true,
 // PLAN SYSTEM
  plan: "gift_trial",

 trialStartAt: now,

  // FREE PLAN LIMITS
  monthlyPostCount: 0,

  trialEndAt: Date.now() + TRIAL_MS,
monthlyPostResetAt: Date.now() + MONTH_MS,
});


console.log("🟡 WRITING TO FIRESTORE:", username);

try {
// PUBLIC
await setDoc(doc(db, "publicUsers", user.uid), {
  username: username,
  accountType: "",
});
 console.log("✅ WRITE SUCCESS");
} catch (e) {
  console.error("❌ FIRESTORE WRITE ERROR:", e);
}

const snap = await getDoc(doc(db, "publicUsers", user.uid));

console.log("📦 FIRESTORE DATA AFTER SAVE:", snap.data());


const checkSnap = await getDoc(doc(db, "publicUsers", user.uid));
if (!checkSnap.exists()) {
  throw new Error("Username write failed");
}


console.log("🧠 SETTING USER CONTEXT:", username);
        setUser({
          uid: user.uid,
          email: user.email,
          username: username,
          verified: true,
          accountType: "",
        });

        setVerified(true);
        setCode("");
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError(err.message || "Something went wrong");
    }

    setLoading(false);
  };

  // ================= GOOGLE SIGN-IN =================
  const handleGoogleSignIn = async () => {
    setError("");
    setLoading(true);

    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

const now = Date.now();

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
  // PRIVATE
  await setDoc(doc(db, "users", user.uid), {
    email: user.email,
    createdAt: new Date().toISOString(),
    verified: true,
  
  plan: "gift_trial",

 trialStartAt: now,

  monthlyPostCount: 0,

  trialEndAt: Date.now() + TRIAL_MS,
monthlyPostResetAt: Date.now() + MONTH_MS,

});

  // PUBLIC
  await setDoc(doc(db, "publicUsers", user.uid), {
  username: user.displayName || user.email.split("@")[0],
  accountType: "",
  });
}

setUser({
  uid: user.uid,
  email: user.email,
  username: user.displayName || user.email.split("@")[0],
  verified: true,
  accountType: "",
});

      navigate("/profile/edit");
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  // ================= UI =================
  return (
    <div className="edit-profile">
      <h2>{t("signup.title")}</h2>

      <form onSubmit={handleSignUp}>
        <input
          type="email"
          placeholder={t("signup.email")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="profile-input"
        />

     <input
  type="text"
  placeholder={t("signup.username")}
  value={username}
  onChange={(e) => setUsername(e.target.value)}
  required
  className="profile-input"
   />

        <input
          type="password"
          placeholder={t("signup.password")}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="profile-input"
        />

        <button
          type="submit"
          className="profile-save-btn"
          disabled={step === "verify" || loading}
        >
          {loading ? t("signup.loading") : t("signup.button")}
        </button>
      </form>

      {/* GOOGLE */}
      <button
        onClick={handleGoogleSignIn}
        disabled={loading}
        style={{ marginTop: 10 }}
        className="google-btn"
      >
        {loading ? t("signup.loading") : t("signup.google")}
      </button>

      {/* VERIFY STEP */}
      {step === "verify" && !verified && (
        <>
          <p style={{ color: "#059668", marginTop: 10 }}>
            {t("signup.checkEmail")}
          </p>

          <input
            type="text"
            placeholder={t("signup.enterCode")}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="profile-input"
          />

          <button
            onClick={handleVerifyCode}
            disabled={loading}
            className="profile-save-btn"
            style={{ marginTop: 10 }}
          >
            {loading
              ? t("signup.loading")
              : t("signup.verify")}
          </button>
        </>
      )}

      {/* SUCCESS */}
      {verified && (
        <>
          <p style={{ color: "#059668", marginTop: 10 }}>
            {t("signup.accountCreated")}
          </p>

          <button
            onClick={() => navigate("/signin")}
            className="profile-save-btn"
            style={{ marginTop: 10 }}
          >
            {t("signup.goToSignIn")}
          </button>
        </>
      )}

      {error && (
        <p style={{ color: "red", marginTop: 10 }}>
          {error}
        </p>
      )}
    </div>
  );
}
